export default "__VITE_ASSET__DSra9vPy__"